/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewPeriodTypeDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewShiftTypeDto } from '../api-models';
/**
 * MetaDataApi - axios parameter creator
 * @export
 */
export const MetaDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaDataPeriodtypeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/MetaData/periodtype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaDataPositionPositionIdShifttypeGet: async (positionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('metaDataPositionPositionIdShifttypeGet', 'positionId', positionId)
            const localVarPath = `/MetaData/position/{positionId}/shifttype`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetaDataApi - functional programming interface
 * @export
 */
export const MetaDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetaDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaDataPeriodtypeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewPeriodTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaDataPeriodtypeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaDataPositionPositionIdShifttypeGet(positionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewShiftTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaDataPositionPositionIdShifttypeGet(positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetaDataApi - factory interface
 * @export
 */
export const MetaDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetaDataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaDataPeriodtypeGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewPeriodTypeDto> {
            return localVarFp.metaDataPeriodtypeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaDataPositionPositionIdShifttypeGet(requestParameters: MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewShiftTypeDto> {
            return localVarFp.metaDataPositionPositionIdShifttypeGet(requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for metaDataPositionPositionIdShifttypeGet operation in MetaDataApi.
 * @export
 * @interface MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest
 */
export interface MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MetaDataApiMetaDataPositionPositionIdShifttypeGet
     */
    readonly positionId: number
}

/**
 * MetaDataApi - object-oriented interface
 * @export
 * @class MetaDataApi
 * @extends {BaseAPI}
 */
export class MetaDataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaDataApi
     */
    public metaDataPeriodtypeGet(options?: AxiosRequestConfig) {
        return MetaDataApiFp(this.configuration).metaDataPeriodtypeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaDataApi
     */
    public metaDataPositionPositionIdShifttypeGet(requestParameters: MetaDataApiMetaDataPositionPositionIdShifttypeGetRequest, options?: AxiosRequestConfig) {
        return MetaDataApiFp(this.configuration).metaDataPositionPositionIdShifttypeGet(requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }
}
